class GoogleMapOverlay extends google.maps.OverlayView {
  div = null
  map = null
  bounds = null
  callback = null
  topPixelOffset = null
  leftPixelOffset = null

  constructor({ map, div, callback }) {
    super()
    this.map = map
    this.div = div
    this.bounds = this.map.getBounds()
    this.callback = callback
    this.callbackTimeout = null
  }

  onAdd() {
    const panes = this.getPanes()
    panes.floatPane.appendChild(this.div)
  }

  draw() {
    const overlayProjection = this.getProjection()
    const sw = overlayProjection.fromLatLngToDivPixel(this.bounds.getSouthWest())
    const ne = overlayProjection.fromLatLngToDivPixel(this.bounds.getNorthEast())

    if (this.div) {
      this.leftPixelOffset = sw.x
      this.topPixelOffset = ne.y

      this.div.style.left = this.leftPixelOffset + 'px'
      this.div.style.top = this.topPixelOffset + 'px'
      this.div.style.width = ne.x - sw.x + 'px'
      this.div.style.height = sw.y - ne.y + 'px'
    }

    if (typeof this.callback === 'function') {
      this.callback()
    }
  }

  onRemove() {
    this.div.remove()
  }

  getPointFromLatLon(latLon) {
    const projection = this.getProjection()

    const pixel = projection.fromLatLngToDivPixel(latLon)

    return {
      x: pixel.x - this.leftPixelOffset,
      y: pixel.y - this.topPixelOffset
    }
  }

  getPointsFromLatLons(latLons) {
    return latLons.map((latLon) => this.getPointFromLatLon(latLon))
  }

  getLatLonFromPoint({ x, y }) {
    const point = new google.maps.Point(x, y)
    return this.getProjection().fromContainerPixelToLatLng(point)
  }

  getLatLonsFromPoints(points) {
    return points.map((point) => this.getLatLonFromPoint(point))
  }
}

export default GoogleMapOverlay